import styled from 'styled-components';
import { InputBase } from '@material-ui/core';

export const StyledDiv = styled.div`
  height: 24px;
  text-align: left;
  font-family: Roboto;
  letter-spacing: 0;
  color: #384164;
  opacity: 1;
  font-size: 20px;
  margin-top: 50px;
  margin-bottom: 32px;
  font-weight: 100;
`;

export const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 13px;
    font-weight: bold;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #384164;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font: 13px;
    color: #2b2727;
    margin-right: 17px;
  }
  .documentContainer {
    width: 200px;
    min-height: 94px;
    margin: 5px 5px;
    background: #f7f7f7 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #0000001a;
    border-radius: 4px;
  }
  .documentTypeContainer {
    width: 200px;
    min-height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 4px 4px 0px 0px;
  }
  .documentType {
    padding: 16px;
    color: #02194e;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    position: absolute;
  }
  .documentTitle {
    padding: 16px;
    color: #02194e;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    cursor: pointer;
  }
  .iconStyle {
    position: relative;
    top: 16px;
    left: 85%;
    cursor: pointer;
  }
  recapDocumentType {
    padding: 8px 16px;
    color: #959595;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    position: absolute;
  }
  .uploaded-docs-div {
    display: flex;
    padding: 10px 5px;
    min-height: 150px;
    align-items: center;
    flex-wrap: wrap;
  }
  .indexed-docs-div {
    display: flex;
    min-height: 150px;
    align-items: center;
  }
  .documentTypeIndexed {
    padding: 16px;
    color: #02194e;
    font-size: 16px;
    font-weight: 600;
    display: flex;
  }
`;
export const BootstrapInput = styled(InputBase)`
  height: 36px;
`;
export const StyledDivUpload = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 3px #0000001f;
  border-radius: 4px;
  padding: 24px;

  .button {
    width: 133px;
    height: 36px;
    background: #f9be00 0% 0% no-repeat padding-box;
  }
  .group {
    height: 36px;
    margin-bottom: 16px;
    width: 60%;
  }
  .titleDoc {
    text-align: left;
    text-transform: inherit;
    font-size: 18px;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #374065;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .uploadInput {
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border: 2px dashed #dfdfdf;
    border-radius: 4px;
    padding: 0px 24px;
    margin: 16px 0px;
  }
  .input {
    width: 70%;
    border-radius: 4;
    border: 1px solid #ced4da;
    font-size: 13px;
    background: #ffffff 0% 0% no-repeat padding-box;
    padding-left: 16px;
  }
  .label {
    text-align: left;
    font-size: 13px;
    font-family: roboto;
    color: #8b8b8b;
    margin: 16px 0px 8px 0px;
  }
  .spanText {
    font-size: 13px;
    font-family: roboto;
    padding-left: 7.8px;
  }
`;
